<template>
    <v-main v-on:drop.prevent class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0"
               style="height: 100%;">
        <v-layout row class="my-10">
            <v-flex md12 sm12>
                <div class="ml-6">
                    <div class="text-center text__colour-teal text__size-32 text__style-bold layout__margin__bottom-20">Select your direct mail template</div>

                    <v-sheet class="mx-auto max-width-1100px">
                        <div v-show="apiTemplates.length > 0">
                            <v-slide-group v-model="model" class="pa-4 select-template-group" show-arrows center-active>
                                <v-slide-item v-for="(template) in apiTemplates" v-bind:key="template.id">
                                    <v-card class="ma-4" width="300">
                                        <v-img 
                                            height="200" 
                                            class="align-end layout__cursor-pointer" 
                                            :src="template.thumbFront" 
                                            :lazy-src="tileLoadingImage" 
                                            contain 
                                            @click="apiTemplateSelection(template)"
                                            @load="imageLoaded()"
                                            @error="imageNotLoaded(template)"
                                        >
                                            <template v-slot:placeholder>
                                                <v-row class="fill-height ma-0" align="center" justify="center">
                                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                            </template>
                                        </v-img>
                                        <div class="pa-2 layout__cursor-pointer" @click="apiTemplateSelection(template)">
                                            <v-card-title class="py-3 my-0">{{template.title}}</v-card-title>
                                            <v-card-subtitle class="py-1 my-0 text__line-height-1">{{template.folder}} - {{template.pageCount}} page</v-card-subtitle>
                                            <v-card-subtitle class="py-1 my-0 text__line-height-1">{{template.dimensions}}</v-card-subtitle>
                                            <v-card-subtitle class="py-1 my-0 text__line-height-1">{{template.orientation}}</v-card-subtitle>
                                        </div>
                                        <v-card-actions class="template-item">
                                            <v-container>
                                                <v-row align="center" justify="center" class="py-2">
                                                    <el-button class="button__base layout__width-200px button__background-red layout__cursor-pointer layout__float-right"
                                                            @click="apiTemplateSelection(template)">Continue
                                                    </el-button>
                                                </v-row>

                                                <v-row align="center" justify="center" class="py-2">
                                                    <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-right"
                                                            @click="previewTemplate(template, 'Front')">Preview Front
                                                    </el-button>
                                                </v-row>

                                                <v-row align="center" justify="center" class="py-2">
                                                    <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-right"
                                                            @click="previewTemplate(template, 'Back')">Preview Back
                                                    </el-button>
                                                </v-row>
                                            </v-container>
                                        </v-card-actions>
                                    </v-card>
                                </v-slide-item>
                            </v-slide-group>
                        </div>

                        <div v-show="apiTemplates.length == 0 && loading == false" class="no-templates">
                            Your saved and uploaded templates will be visible here
                        </div>

                        <div class="layout__padding__top-40px">
                            <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-left"
                                    v-on:click="navigate('select-design-type');">Back
                            </el-button>

                            <div class="layout__float-right">
                                <span class="filter-label">Filter:&nbsp;&nbsp;&nbsp;</span>
                                <el-input autofocus v-model="filter" clearable class="inline-block filter-field layout__float-right" id="filterTextField"
                                    v-on:input="filterTemplates()">
                                </el-input>
                            </div>
                        </div>
                    </v-sheet>

                    <v-dialog v-model="imagePreviewDialog"
                            content-class="display--white"
                            persistent max-width="800px">
                        <v-img 
                            height="800"
                            class="align-end"
                            :src="imagePreviewUrl"
                            :lazy-src="tileLoadingImage"
                            contain 
                        >
                            <template v-slot:placeholder>
                                <v-row class="fill-height ma-0" align="center" justify="center">
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-row>
                            </template>
                        </v-img>

                        <v-row align="center" justify="center" class="py-2">
                            <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-right"
                                    v-on:click="imagePreviewDialog = false">Close
                            </el-button>
                        </v-row>
                    </v-dialog>

                    <v-overlay :value="loading">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </div>
            </v-flex>

            <v-snackbar v-model="retrieveTemplates" color="error" :top="true" :timeout="5000">
                Sorry there has been a problem retrieving template information. Please try again.
                <v-btn dark text @click="retrieveTemplates = false">
                    Close
                </v-btn>
            </v-snackbar>

        </v-layout>
    </v-main>
</template>

<script>
    import Router from '../../router.js';
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';

    export default {
        name: 'InstantMarketingTemplate',
        components: {
        },
        mixins: [axios],
        data: () => ({
            model: null,
            loading: false,
            apiTemplatesOrig: [],
            apiTemplates: [],
            productsHolding: [],
            preference: '',
            preferences: {},
            filter: '',
            retrieveTemplates: false,
            imagesLoaded: 0,
            tileLoadingImage: '',
            imagePreviewDialog: false,
            imagePreviewUrl: '',
            customersCanvasApiKey: `${process.env.VUE_APP_CUSTOMERS_CANVAS_API_KEY}`,
        }),
        watch: {
        },
        mounted() {
            this.loading = true;
            this.imagesLoaded = 0;

            window.sessionStorage.removeItem('_loadGenericTemplate');

            var customer = JSON.parse(window.sessionStorage.getItem('customer'));

            if (window.sessionStorage.getItem('templatingValues') !== "undefined") {
                var templatingValues = JSON.parse(window.sessionStorage.getItem('templatingValues'));
                this.tileLoadingImage = templatingValues.varCompany_Logo_1;
            } else {
                this.tileLoadingImage = 'https://rpsassets.blob.core.windows.net/rpsimages/images/instant_marketing/Ravensworth_Image_Tile.png';
            }

            var cl = document.getElementsByClassName('mdi-chevron-left');
            cl[0].addEventListener('click', this.chevronLeft);

            var cr = document.getElementsByClassName('mdi-chevron-right');
            cr[0].addEventListener('click', this.chevronRight);

            window.sessionStorage.removeItem('imageUrl');
            let getTemplates = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Artwork/FindArtworkTemplates?CustomerRefFilter=${customer.ref}`;

            //can be my-templates or template-gallery
            var templateType = window.sessionStorage.getItem('_templateType');

            if (templateType == 'template-gallery') {
              getTemplates += '&ShowGallery=1';
            }

            Axios.get(getTemplates)
                .then(response => {

                    console.log(response.data.result)
                    response.data.result.forEach(template => {
                        console.log(template);

                        var dimensions = template.pageWidth + 'mm (w) x ' + template.pageHeight + 'mm (h)',
                            orientation = (template.pageHeight > template.pageWidth) ? "Portrait" : (template.pageHeight < template.pageWidth ? "Landscape" : "Square");

                        //console.log('testdatajson=' + JSON.stringify(template.testDataJson == undefined ? '{}' : template.testDataJson));

                        this.apiTemplatesOrig.push({
                            id: template.id,
                            title: template.name,
                            name: template.name,
                            masterUrl: template.masterUrl,
                            url: template.masterUrl.replace('.idml', ''),
                            thumb: template.thumbUrl.substr(0, template.thumbUrl.indexOf('||')),
                            thumbFront: template.thumbUrl.split('||')[0],
                            thumbBack: template.thumbUrl.split('||')[1],
                            customerRef: template.customerRef,
                            userId: template.userId,
                            fCode: template.fCode,
                            hide: !template.isActive,
                            folder: template.folder,
                            saved: template.saved,
                            jsonData: template.testDataJson,
                            isGeneric: template.isGeneric,
                            pageCount: template.pageCount,
                            pageHeight: template.pageHeight,
                            pageWidth: template.pageWidth,
                            dimensions: dimensions,
                            orientation: orientation,
                        })
                    })

                    var filtered = this.apiTemplatesOrig.filter(function(item){
                        return item.hide == false;
                    });

                    this.apiTemplatesOrig = filtered;

                    this.apiTemplatesOrig.sort((a, b) => {
                        if (a.name < b.name)
                            return -1;
                        if (a.name > b.name)
                            return 1;
                        return 0;
                    });

                    var filtered = this.apiTemplatesOrig.filter(function(item){
                        /*var ext = item.masterUrl.split('.').pop();

                        if (templateType == 'my-templates') {
                            return ext == 'st';
                        }

                        if (templateType == 'template-gallery') {
                            return ext == 'idml';
                        }*/

                        if (templateType == 'my-templates') {
                            return !item.isGeneric && item.customerRef == customer.ref;
                        }

                        if (templateType == 'template-gallery') {
                            return item.isGeneric;
                        }
                    });

                    this.apiTemplatesOrig = filtered;

                    if (this.apiTemplatesOrig.length == 0) {
                        this.loading = false;
                    }

                    this.apiTemplates = this.apiTemplatesOrig;

                    parent.postMessage('ScrollIntoView', '*');
                })
                .catch(error => {
                    console.log(error);

                    this.retrieveTemplates = true;
                    this.loading = false;
                })
        },
        methods: {
            chevronLeft(e) {
                console.log('chevronLeft');

                e.stopPropagation();

                document.getElementsByClassName('v-slide-group__next')[0].classList.remove('v-slide-group__next--disabled');
                document.getElementsByClassName('mdi-chevron-right')[0].classList.remove('v-icon--disabled');

                var scrollLeft = document.getElementsByClassName('v-slide-group__wrapper')[0].scrollLeft;
                document.getElementsByClassName('v-slide-group__wrapper')[0].scrollLeft = scrollLeft - 1000;
            },
            chevronRight(e) {
                console.log('chevronRight');

                e.stopPropagation();

                document.getElementsByClassName('v-slide-group__prev')[0].classList.remove('v-slide-group__prev--disabled');
                document.getElementsByClassName('mdi-chevron-left')[0].classList.remove('v-icon--disabled');

                var scrollLeft = document.getElementsByClassName('v-slide-group__wrapper')[0].scrollLeft;
                document.getElementsByClassName('v-slide-group__wrapper')[0].scrollLeft = scrollLeft + 1000;
            },
            navigate(path) {
                Router.push({
                    path: '/' + path,
                });
            },
            async apiTemplateSelection(template) {
                console.log(template);
                console.log(typeof template);

                if (template.jsonData === undefined) {
                    window.sessionStorage.removeItem('_mockupFile');
                    window.sessionStorage.removeItem('_priceCodes');
                } else {
                    var jsonData = JSON.parse(template.jsonData.replace(/\"/g, "\""));
                    console.log(jsonData);
                    console.log(jsonData.mockupFile);
                    console.log(jsonData.priceCodes);

                    jsonData.priceCodes.forEach(function(priceCode) { 
                        console.log(priceCode);
                    });

                    window.sessionStorage.setItem('_mockupFile', jsonData.mockupFile);
                    window.sessionStorage.setItem('_priceCodes', jsonData.priceCodes);
                }

                this.loading = true;

                window.sessionStorage.setItem('_template', JSON.stringify(template));

                window.sessionStorage.removeItem("stateId");

                console.log('file extension=' + this.getFileExtension(template.url));

                //If a named state file is chosen then copy it to a guid state file to prevent the original from being overwritten
                if (this.getFileExtension(template.url) == 'st') {

                    var customer = JSON.parse(window.sessionStorage.getItem('customer')),
                        stateId = this.generateUUID(),
                        endpoint = `${process.env.VUE_APP_CANVASURL}/api/users/` + customer.ref + '/states/' + stateId,
                        masterStateId = template.url.replace('.st', '');

                    // var customerRef;
                    // if (template.isGeneric) {
                    //     customerRef = 'masteruser';
                    // } else {
                    //     customerRef = customer.ref;
                    // }

                    // const parameters = {
                    //     "CopyFrom": {
                    //         "UserId": customerRef,
                    //         "StateId": masterStateId
                    //     },
                    //     "Overwrite": false
                    // };

                    // console.log('endpoint=' + endpoint);
                    // console.log(parameters);

                    // const headers = {
                    //     "X-CustomersCanvasAPIKey": this.customersCanvasApiKey,
                    //     "Content-Type": "application/json"
                    // }

                    // console.log(headers);

                    // await Axios({
                    //         method: 'post',
                    //         url: endpoint,
                    //         headers: headers, 
                    //         data: JSON.stringify(parameters)
                    //     })
                    //     .then(response => {
                    //         console.log(response);

                    //         window.sessionStorage.setItem("stateId", stateId);
                    //     })
                    //     .catch(error => {
                    //         console.log(error);

                    //     })
                }

                const patch_order = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + window.sessionStorage.getItem('_order_id');
                const update_body = [
                    {
                        "value": template.id,
                        "path": "/templateId",
                        "op": "replace",
                        "from": "string"
                    },
                    {
                        "value": template.fCode,
                        "path": "/printJobSpec/fCode",
                        "op": "replace",
                        "from": "string"
                    },
                    {
                        "value": template.name,
                        "path": "/printJobSpec/name",
                        "op": "replace",
                        "from": "string"
                    },
                    {
                        "value": template.pageWidth,
                        "path": "/printJobSpec/pageWidth",
                        "op": "replace",
                        "from": "string"
                    },
                    {
                        "value": template.pageHeight,
                        "path": "/printJobSpec/pageHeight",
                        "op": "replace",
                        "from": "string"
                    },
                    {
                        "value": template.pageCount,
                        "path": "/printJobSpec/pageCount",
                        "op": "replace",
                        "from": "string"
                    }
                ]

                Axios.patch(patch_order, update_body, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response.data);

                        //Preferences stuff here
                        const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindProductsAsync`

                        const getProducts = {
                            "id": 0,
                            "fCode": "",
                            "stockType": "string",
                            "pageWidth": template.pageWidth,
                            "pageHeight": template.pageHeight,
                            "actualPageWidth": 0,
                            "actualPageHeight": 0,
                            "pageOrientation": "string",
                            "stockWeight": "string",
                            "lamination": "string",
                            "pageCount": template.pageCount,
                            "quantity": 0
                        }

                        Axios.post(url, getProducts, this.returnHeaderUsingToken())
                            .then(response => {
                                this.productsHolding = response.data;

                                console.log(response);
                                console.log(this.productsHolding.length);

                                if (this.productsHolding.length === 0) {
                                    console.log('0 matching products');
                                    this.loading = false;

                                    this.navigate('personalise-design');
                                } else {
                                    console.log(JSON.parse(this.returnCookie('_myPreferences')));
                                    
                                    if (JSON.parse(this.returnCookie('_myPreferences'))) {
                                        const listOfAllPreferences = JSON.parse(this.returnCookie('_myPreferences'))

                                        for (let i = 0; i < this.productsHolding.length; i++) {
                                            let current_matched_product = this.productsHolding[i];

                                            for (let indexing = 0; indexing < listOfAllPreferences.length; indexing++) {
                                                let current_preference = listOfAllPreferences[indexing];

                                                console.log('current_matched_product.code[0]=' + current_matched_product.code.split('A')[0]);
                                                console.log('current_preference.fCode=' + current_preference.fCode);
                                                console.log('match=' + current_preference.fCode === current_matched_product.code.split('A')[0]);

                                                if (current_preference.fCode === current_matched_product.code.split('A')[0]) {
                                                    this.preference = current_preference;
                                                    console.log('BREAKING OUT OF LOOP - CREATED MORE THAN ONE MATCHED PRODUCT');
                                                    break;
                                                }
                                            }

                                            if (this.preference) {
                                                break;
                                            }
                                        }

                                        if (template.fCode === this.preference.fCode) {
                                            this.preferences = this.preference;
                                        } else {
                                            this.preferences = {
                                                "fCode": '',
                                                "finishing": '',
                                                "pageCount": 0,
                                                "pageHeight": 0,
                                                "pageOrientation": '',
                                                "pageWidth": 0,
                                                "quantity": 0,
                                                "stockType": '',
                                                "stockWeight": '',
                                                "productRef": ''
                                            }
                                        }
                                    } else {
                                        console.log('no preferences that match single product selected')
                                        this.preferences = {
                                            "fCode": '',
                                            "finishing": '',
                                            "pageCount": 0,
                                            "pageHeight": 0,
                                            "pageOrientation": '',
                                            "pageWidth": 0,
                                            "quantity": 0,
                                            "stockType": '',
                                            "stockWeight": '',
                                            "productRef": ''
                                        }
                                    }

                                    window.sessionStorage.setItem('_imPreference', JSON.stringify(this.preferences))

                                    if (template.isGeneric) {
                                        window.sessionStorage.setItem('_loadGenericTemplate', true);
                                    }

                                    this.loading = false;

                                    this.navigate('personalise-design');
                                }
                            })
                            .catch(error => {
                                console.log(error)
                                this.loading = false;
                            });
                    })
                    .catch(error => {
                        console.log(error)
                        this.loading = false;
                    });
            },
            previewTemplate(template, side) {
                console.log('previewTemplate');

                //var previewImage = template.thumb.replace(/=300/g, '=800');
                var previewImage;

                if (side == 'Front') {
                    previewImage = template.thumbFront.replace(/=300/g, '=800');
                }

                if (side == 'Back') {
                    previewImage = template.thumbBack.replace(/=300/g, '=800');
                }

                this.imagePreviewUrl = previewImage;
                this.imagePreviewDialog = true;
            },
            getFileExtension(filename) {
                return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
            },
            imageLoaded() {
                console.log('image loaded');

                this.imagesLoaded++;

                if (! this.imagesLoaded < this.apiTemplates.length) {
                    this.loading = false;
                }
            },
            imageNotLoaded(template) {
                console.log('image not loaded - ' + template.name);

                // var customer = JSON.parse(window.sessionStorage.getItem('customer')),
                //     template = JSON.parse(window.sessionStorage.getItem('_template'));
                var customer = JSON.parse(window.sessionStorage.getItem('customer'));

                var inputData = {
                    productDefinitions: [template.masterUrl.replace('.st', '')],
                    userId: template.customerRef
                };

                // var endpoint = `https://cc.ravensworth.uk/api/Preview/GeneratePreview/`;
                var endpoint = `${process.env.VUE_APP_CANVASURL}/api/Preview/GeneratePreview`

                const headers = {
                    "X-CustomersCanvasAPIKey": this.customersCanvasApiKey,
                    "Content-Type": "application/json"
                }

                Axios({
                    method: 'post',
                    url: endpoint,
                    headers: headers,
                    data: JSON.stringify(inputData)
                })
                    .then(response => {
                        console.log(response);

                        console.log(response.data[0][0][0]);
                        console.log(response.data[0][1][0]);

                        // var resultObject = this.search(template.id, this.apiTemplates);
                        // console.log(JSON.stringify(resultObject));

                        for (var i in this.apiTemplates) {
                            if (this.apiTemplates[i].id == template.id) {
                                this.apiTemplates[i].thumb = response.data[0][0][0] + '||' + response.data[0][1][0];
                                this.apiTemplates[i].thumbFront = response.data[0][0][0];
                                this.apiTemplates[i].thumbBack = response.data[0][1][0];
                                break;
                            }
                        }

                        const templateDetails = {
                            "id": template.id,
                            "name": template.name,
                            "masterUrl": template.masterUrl,
                            "customerRef": template.customerRef,
                            "fCode": template.fCode,
                            "thumbUrl": response.data[0][0][0] + '||' + response.data[0][1][0],
                            "saved": template.saved,
                            "isActive": true,
                            "folder": template.folder,
                            "isGeneric": false,
                            "pageCount": template.pageCount,
                            "pageHeight": template.pageHeight,
                            "pageWidth": template.pageWidth,
                            "userId": template.userId
                        }

                        console.log('templateDetails: ' + JSON.stringify(templateDetails));

                        endpoint = `${process.env.VUE_APP_TKGATEWAY}/api/services/app/Artwork/AddArtworkTemplate`;

                        Axios.post(endpoint, templateDetails, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log(response);

                            })
                            .catch(error => {
                                console.log(error);

                            })
                    })
                    .catch(error => {
                        console.log(error);
                    })

                this.imagesLoaded++;

                if (! this.imagesLoaded < this.apiTemplates.length) {
                    this.loading = false;
                }
            },
            search(idKey, myArray){
                for (var i=0; i < myArray.length; i++) {
                    if (myArray[i].id === idKey) {
                        return myArray[i];
                    }
                }
            },            
            generateUUID: function() {
                var d = new Date().getTime();
                if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
                    d += performance.now(); //use high-precision timer if available
                }
                var newGuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                
                return newGuid;
            },
            filterTemplates() {
                var _this = this;

                var filtered = this.apiTemplatesOrig.filter(function(item){
                    return item.name.toLowerCase().includes(_this.filter.toLowerCase()) == true;
                });

                this.apiTemplates = filtered;

                this.apiTemplates.sort((a, b) => {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                });
            }
        }
    };
</script>
